import React, { useState } from 'react'
import { Stepper, Step, StepLabel, StepContent, Typography, Button as ButtonUI } from '@material-ui/core';
import moment from 'moment';
import {Row, Col} from 'react-bootstrap';


//TRAIGO LOS COMPONENTES DE LOS PASOS
import PrimerPaso from './PrimerPaso';
import SegundoPaso from './SegundoPaso';
import TercerPaso from './TercerPaso';
//import CuartoPaso from './CuartoPaso';

//MATERIAL UI CARD  
import { Card, CardContent } from '@material-ui/core';

import ErrorIcon from '@material-ui/icons/Error';


const Pasos = (props) => {
    //Obtengo el prop con la info de los pasos
    const { data } = props;

    //ESTADOS
    const [activeStep, setActiveStep] = useState(data && data.estado !== '3' ? 0 : 2);

    function handleNext() {
        setActiveStep(prevActiveStep => prevActiveStep + 1);
    };

    function handleBack() {
        setActiveStep(prevActiveStep => prevActiveStep - 1);
    };

    // const handleReset = () => {
    //     setActiveStep(0);
    // };

    

    if (data) {
        //SACO LOS ESTABLECIMIENTOS APROBADOS PARA EL SORTEO
        const establecimientosAprobados = data.establecimientosSeleccionados.filter(filtrado => filtrado.ingreso);
        //ARRAY DE PASOS USADOS PARA EL MAPEO EN EL JSX
        const steps = [
            { nombre: 'Registro del Aspirante', paso: <PrimerPaso responsables={data.responsables} establecimientos={data.establecimientosSeleccionados} /> },
            //  { nombre: 'Confirmación de los Datos', paso: <SegundoPaso establecimientos={establecimientosAprobados} /> },
            { nombre: 'Sorteo', paso: <TercerPaso estado={data.estado} /> },
            { nombre: 'Resultado', paso: <SegundoPaso establecimientos={establecimientosAprobados} /> }
        ];

        //FECHA HOY
        const segundoLlamado = moment([2024,1,18]);
        const creacion = moment(data.fechaCreacion);

        return (
            <>
                <div className="text-center">
                    {/* <h2>Información del Aspirante</h2> */}
                    <h3><b>{data.aspirante.apellido}, {data.aspirante.nombre}</b></h3>
                    <h5><u>DNI:</u> {data.aspirante.dni}</h5>
                </div>
                {data.estado !== '3' &&
                    <div className="row justify-content-center mt-8">
                        <Card className="col-12 col-md-10" style={{ backgroundColor: "#f7f7f7" }}>
                            <CardContent className="d-flex align-items-center ml-2">
                                <div className="border-left border-2 border-danger p-3 br-4">
                                    <ErrorIcon className="text-danger" fontSize="large" />
                                </div>
                                <div>
                                    <b>IMPORTANTE</b>
                                    <p>Esta inscripción aún no se sorteó, debe esperar a la próxima fecha de sorteo</p>
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                }
                <Row className="mt-8 justify-content-center">
                    <Col md={10}>
                        <div class="d-flex">
                            <h6><u>Llamado</u>: {(segundoLlamado.diff(creacion, 'days') <= 0) ? "2" : "1"} </h6>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <h6><u>Número de Sorteo</u>: {data.nroSorteo}</h6>
                        </div>
                    </Col>
                    <Col md={10}>
                        <h6><u>Nivel Seleccionado</u>: {data.nivel} - {data.curso}</h6>
                    </Col>
                    <Col md={10}>
                        <h6><u>Fecha de Inscripción</u>: {moment(data.fechaCreacion).format("DD/MM/YYYY - HH:mm")} Hs.</h6>
                    </Col>
                </Row>
                <Row className="justify-content-center">
                    <Col lg={10}>
                        <Stepper activeStep={activeStep} orientation="vertical">
                            {steps.map((item, i) => (
                                <Step key={i}>
                                    <StepLabel><h5 className="pt-2">{item.nombre}</h5></StepLabel>
                                    <StepContent>
                                        <Typography component="span">{item.paso}</Typography>
                                        <div className="mt-2">
                                            {activeStep > 0 &&
                                                <ButtonUI 
                                                    className="mr-2" 
                                                    variant="contained" 
                                                    color="secondary"
                                                    onClick={handleBack} 
                                                >
                                                    Atras
                                                </ButtonUI>
                                            }
                                            {activeStep < 2 &&
                                                <ButtonUI 
                                                    style={{ color: 'white' }} 
                                                    className="ml-2" 
                                                    variant="contained" 
                                                    color="primary" 
                                                    onClick={handleNext}
                                                    disabled={data.estado !== '3'}
                                                >
                                                    Siguiente
                                                </ButtonUI>
                                            }
                                        </div>
                                    </StepContent>
                                </Step>
                            ))}
                        </Stepper>
                        {/*activeStep === steps.length &&
                            <ButtonUI style={{ color: 'white' }} className="ml-2" variant="contained" color="primary" onClick={handleReset}>Ver de Nuevo</ButtonUI>
                        */}
                    </Col>
                </Row>
            </>
        )
    } else {
        return (
            <div className="text-center">
                <h2>Información del Aspirante No Encontrada</h2>
            </div>
        )
    }

}

export default Pasos;